package com.example.event_management_system.data.models

import kotlinx.serialization.Serializable

@Serializable
enum class UserRole {
    OWNER,
    MANAGER,
    STAFF
}
